import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  proveedores: [],
  totalCount: 0,
  loading: false,
}

export const Slice = createSlice({
  name: 'proveedores',
  initialState,
  reducers: {
    setProveedores: (state, action) => {
      state.proveedores = action.payload
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
  },
})

export const { setProveedores, setTotalCount, setLoading } = Slice.actions
export default Slice.reducer
